import { isWebGLSupported } from "pixi.js";

let software: boolean | undefined;

/**
 * Whether the browser draws without the graphics card: graphics acceleration turned off in its settings, switched off by
 * the browser itself (Chrome does so after its graphics process crashes, until it's restarted), or a card it won't use.
 * WebGL then runs on the processor (Chrome's SwiftShader) or not at all, which is many times slower: a player saw 29
 * frames a second until they turned the setting off and on and restarted Chrome. Asked once per visit (it opens a WebGL
 * context that fails on a major performance caveat).
 *
 * While it's so, the game draws its lightest way (the Low look, no antialiasing, one pixel per screen pixel) and the menu
 * says how to turn acceleration back on (#splash-hw-acceleration-warning); nothing is saved, so the player's own
 * settings are back as soon as the graphics card is.
 */
export const softwareRendering = (): boolean => (software ??= !isWebGLSupported(true));
